<div class="slider-container">
  <div class="slides">
    <div
      class="slide"
      [ngStyle]="{
        'background-image': 'url(' + slides[currentSlide] + ')',
        opacity: hidden ? 0 : 1,
        transition: 'opacity ' + animationSpeed + 'ms ease-in-out'
      }"
    ></div>
  
    <button (click)="next()" class="nextButton" *ngIf="slides.length > 1">
      <span class="material-symbols-outlined nextButtonIcon">
        chevron_right
      </span>
    </button>
    <button (click)="previous()" class="previousButton" *ngIf="slides.length > 1">
      <span class="material-symbols-outlined previousButtonIcon">
        chevron_left
      </span>
    </button>
  </div>
  
  @if (indicatorsVisible && slides.length > 1) {
    <div class="indicators">
      <ng-container *ngFor="let slide of slides;let i = index">
        <div
        (click)="jumpToSlide(i)"
        (keydown.enter)="jumpToSlide(i)"
        tabindex="0"
        class="indicator"
        [ngClass]="{ active: i === currentSlide }"
      ></div>
      </ng-container>
    </div>
  }

  @if (indicatorsVisible && slides.length > 1) {
    <div class="image-indicators">
      <ng-container *ngFor="let slide of slides;let i = index">
        <div
        [ngStyle]="{
          'background-image': 'url(' + slide + ')'
        }"
        class="image-indicator"
        [ngClass]="{ active: i === currentSlide }"
        (click)="jumpToSlide(i)"
        (keydown.enter)="jumpToSlide(i)"
        tabindex="0"
        ></div>
      </ng-container>
    </div>
  }
</div>